import React, { Component } from 'react'
import styles from './App.css'
import 'bootswatch/flatly/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import { Route, Redirect } from 'react-router-dom'
import Home from '../home/Home'
import NavigationBar from '../navigationbar/NavigationBar'

const backendAddress = window.location.protocol + '//' + window.location.hostname + ':' + (process.env.NODE_ENV === 'production' ? '443' : '55522')

class App extends Component {
  render() {
    return (
      <div>
        <main className={styles.background}>
          <NavigationBar />
          <Route exact path='/home' render={function() {return <Redirect to={'/home/welcome'} />;}} />
          <Route path='/home/:section' component={Home} />
          <Route path='/partner' render={function() {window.location.href= backendAddress + "/partner";}} />
        </main>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/containers/app/App.js